(function () {
  var PAGE = 8;
  var openPopover = null;

  function slug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&amp;/g, " ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function params() {
    return new URLSearchParams(window.location.search);
  }

  function writeUrl(mutate) {
    var next = params();
    mutate(next);
    var query = next.toString();
    history.pushState({ noirplate: true }, "", window.location.pathname + (query ? "?" + query : ""));
  }

  function closePopover() {
    if (openPopover && openPopover.parentNode) openPopover.parentNode.removeChild(openPopover);
    openPopover = null;
  }

  function facetsFor(card, index) {
    var handleNode = card.querySelector("[data-product-handle]");
    var heading = card.querySelector("h2, h3, h4");
    var blob = ((handleNode && handleNode.getAttribute("data-product-handle")) || "") + " " + text(heading) + " " + text(card);
    var lower = blob.toLowerCase();
    var theme = "";
    var rules = [
      ["flowers", /peony|tulip|poppy|anemone|wildflower|flower/],
      ["botanical", /olive|fern|botanical|eucalyptus|flora|ginkgo|herb|monstera|lunaria/],
      ["black-white", /brutalist|monochrome|slate|noir/],
      ["photography", /coast|paris|harbour|harbor|alpine|palma|balcony|skagen|berlin|concrete|pines/],
      ["bauhaus", /bauhaus/],
      ["typography", /typograph|verse/],
      ["illustrations", /reader|silhouette|ceramic|pomegranate|trace/],
      ["minimalist", /quiet|linen|oat|plaster|horizon/],
      ["abstract", /abstract|geometry|ochre|terracotta|aura|shapes|form|resonance/],
      ["nature", /garden|forest|lake|dune|mist/],
      ["animals", /horse|fox|heron|hound/]
    ];
    rules.forEach(function (rule) {
      if (!theme && rule[1].test(lower)) theme = rule[0];
    });
    var sizeMatch = lower.match(/(\d+)\s*[×x]\s*(\d+)/);
    var sizes = ["5x7", "8x12", "12x16", "16x20", "20x28", "28x39", "39x59"];
    var size = sizeMatch ? sizeMatch[1] + "x" + sizeMatch[2] : sizes[index % sizes.length];
    var color = "sand";
    if (/black|noir|slate/.test(lower)) color = "black";
    else if (/white|plaster|linen|oat/.test(lower)) color = "white";
    else if (/blue|coast|sea/.test(lower)) color = "blue";
    else if (/green|fern|olive|botanical/.test(lower)) color = "green";
    else if (/ochre|terracotta|umber|tuscan/.test(lower)) color = "terracotta";
    else if (/pink|blush|peony/.test(lower)) color = "pink";
    else if (/red|poppy/.test(lower)) color = "red";
    else if (/grey|gray/.test(lower)) color = "grey";
    var tab = "new_this_week";
    if (/sculpt|geometry|shadow|trace|arch|woven|form/.test(lower)) tab = "modern_sculptural";
    else if (/umber|ochre|terra|tuscan|pomegranate|botanical stem/.test(lower)) tab = "warm_earth_tones";
    else if (/atelier|exclusive|studio|oat|linen/.test(lower)) tab = "studio_noir_exclusive";
    var finish = "";
    if (/dark oak/.test(lower)) finish = "dark-oak";
    else if (/white frame|white wood/.test(lower)) finish = "white";
    else if (/natural oak|oak frame|oak wood/.test(lower) || (/\boak\b/.test(lower) && !/dark/.test(lower))) finish = "oak";
    else if (/metal|aluminum|brass/.test(lower)) finish = "metal";
    else if (/black/.test(lower) && /frame/.test(lower)) finish = "black";
    else if (/mat|hanger|ledge|hook|clip|stand/.test(lower)) finish = "accessory";
    var material = /canvas/.test(lower) ? "canvas" : /oak|wood/.test(lower) ? "wood" : /metal/.test(lower) ? "metal" : "paper";
    var room = /kitchen|dining|herb|pear/.test(lower) ? "kitchen" : /bed|calm/.test(lower) ? "bedroom" : /office|concrete|berlin/.test(lower) ? "office" : /kid|fox|boat/.test(lower) ? "kids" : /hall/.test(lower) ? "hallway" : "living-room";
    var style = /play|fox|boat/.test(lower) ? "playful" : /bold|bauhaus|poppy/.test(lower) ? "bold" : /romantic|peony/.test(lower) ? "romantic" : /minimal|quiet|linen/.test(lower) ? "minimal" : "contemporary";
    return { theme: theme, color: color, size: size, style: style, room: room, tab: tab, finish: finish, material: material };
  }

  function priceOf(card) {
    var match = text(card).match(/\$([0-9]+(?:\.[0-9]+)?)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function titleOf(card) {
    var heading = card.querySelector("h2, h3, h4");
    return text(heading).toLowerCase();
  }

  function findProductGrid() {
    if (document.querySelector("[data-shopify-catalog]")) return null;
    var best = null;
    var count = 0;
    document.querySelectorAll(".grid").forEach(function (grid) {
      if (grid.closest("[data-shopify-catalog]")) return;
      var found = grid.querySelectorAll("[data-quick-view]").length;
      if (found > count) {
        count = found;
        best = grid;
      }
    });
    return count > 0 ? best : null;
  }

  function cardsIn(grid) {
    var list = [];
    Array.prototype.forEach.call(grid.children, function (child) {
      if (child.querySelector && child.querySelector("[data-quick-view]")) list.push(child);
    });
    return list;
  }

  function hostOf(grid) {
    return grid.parentElement;
  }

  function findControl(host, pattern) {
    var nodes = host ? host.querySelectorAll("a, button, p, span, div") : [];
    var match = null;
    Array.prototype.forEach.call(nodes, function (node) {
      if (match || node.children.length > 6) return;
      if (pattern.test(text(node)) && text(node).length < 80) match = node;
    });
    return match;
  }

  function catalogState() {
    var query = params();
    return {
      theme: query.get("theme") || "",
      color: query.get("color") || "",
      size: query.get("size") || "",
      style: query.get("style") || "",
      room: query.get("room") || "",
      tab: query.get("tab") || "",
      finish: query.get("finish") || "",
      material: query.get("material") || "",
      sort: query.get("sort_by") || "manual",
      page: Math.max(1, parseInt(query.get("page") || "1", 10)),
      append: query.get("viewmode") === "append"
    };
  }

  function matches(card, state) {
    var data = card.dataset;
    if (state.theme && data.theme !== state.theme) return false;
    if (state.color && data.color !== state.color) return false;
    if (state.size && data.size !== state.size) return false;
    if (state.style && data.style !== state.style) return false;
    if (state.room && data.room !== state.room) return false;
    if (state.tab && data.tab !== state.tab) return false;
    if (state.finish && data.finish !== state.finish) return false;
    if (state.material && data.material !== state.material) return false;
    return true;
  }

  function applyCatalog(grid, cards) {
    var state = catalogState();
    var visible = cards.filter(function (card) { return matches(card, state); });
    var sorted = visible.slice();
    if (state.sort === "price-ascending" || state.sort === "price-descending") {
      sorted.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      if (state.sort === "price-descending") sorted.reverse();
    } else if (state.sort === "title-ascending" || state.sort === "title-descending") {
      sorted.sort(function (a, b) { return titleOf(a).localeCompare(titleOf(b)); });
      if (state.sort === "title-descending") sorted.reverse();
    } else if (state.sort === "created-descending") {
      sorted.reverse();
    }
    sorted.forEach(function (card) { grid.appendChild(card); });
    var start = state.append ? 0 : (state.page - 1) * PAGE;
    var end = state.append ? state.page * PAGE : start + PAGE;
    cards.forEach(function (card) {
      var index = sorted.indexOf(card);
      var show = index >= start && index < end;
      card.style.display = show ? "" : "none";
    });
    var shown = Math.min(end, sorted.length) - (state.append ? 0 : start);
    if (shown < 0) shown = 0;
    var host = hostOf(grid);
    var previous = host.previousElementSibling;
    var countNode = findControl(host, /showing|curated works|curated releases|archival objects/i) || (previous && findControl(previous, /showing|curated works|curated releases|archival objects/i));
    if (countNode) {
      var from = sorted.length ? (state.append ? 1 : start + 1) : 0;
      var to = state.append ? Math.min(state.page * PAGE, sorted.length) : Math.min(start + PAGE, sorted.length);
      countNode.textContent = sorted.length ? "Showing " + from + "–" + to + " of " + sorted.length : "No pieces match these filters";
    }
    document.querySelectorAll("span").forEach(function (node) {
      if (/certified monograph editions/i.test(text(node))) node.textContent = cards.length + " Certified Monograph Editions";
    });
    var more = findControl(host, /show more|load more artwork/i) || findControl(document.body, /show more prints|show more products|load more artwork|show more curated/i);
    if (more && !more.closest("[data-shopify-catalog]") && !more.closest("[data-shopify-journal]")) {
      var remaining = sorted.length > (state.append ? state.page * PAGE : (state.page * PAGE));
      var hasNext = state.append ? sorted.length > state.page * PAGE : state.page * PAGE < sorted.length;
      more.hidden = !hasNext;
      more.style.display = hasNext ? "" : "none";
    }
    paintPager(host, Math.max(1, Math.ceil(sorted.length / PAGE)), state.page, sorted.length > 0);
    paintEmpty(grid, sorted.length === 0);
    paintChipState(state);
    var allNew = findControl(document.body, /all new in/i);
    if (allNew && !state.tab) {
      allNew.textContent = "All New In (" + cards.length + ")";
    }
  }

  function paintEmpty(grid, empty) {
    var note = document.getElementById("CatalogEmpty");
    if (!empty) {
      if (note) note.remove();
      return;
    }
    if (note) return;
    note = document.createElement("div");
    note.id = "CatalogEmpty";
    note.className = "col-span-full border border-surface-variant bg-surface-container-low p-10 text-center";
    note.innerHTML = '<p class="font-headline-sm text-headline-sm text-primary mb-3">No pieces match these filters</p><button type="button" class="h-12 px-6 bg-primary text-on-primary font-label-caps text-label-caps uppercase tracking-widest" data-clear-filters>Clear all</button>';
    grid.appendChild(note);
  }

  function paintPager(host, pages, current, enabled) {
    var nav = host.querySelector("nav[aria-label='Pagination']") || findControl(host, /^‹|‹/);
    if (!nav) return;
    if (!enabled || pages < 2) {
      nav.innerHTML = "";
      nav.style.display = "none";
      return;
    }
    nav.style.display = "";
    var html = "";
    html += current > 1 ? '<a class="p-2 hover:text-primary" href="' + pageHref(current - 1) + '" data-page="' + (current - 1) + '">‹</a>' : '<span class="p-2 text-outline">‹</span>';
    for (var i = 1; i <= pages; i += 1) {
      if (i === current) html += '<span aria-current="page" class="w-8 h-8 inline-flex items-center justify-center bg-primary text-on-primary">' + i + "</span>";
      else html += '<a class="w-8 h-8 inline-flex items-center justify-center hover:bg-surface-container" href="' + pageHref(i) + '" data-page="' + i + '">' + i + "</a>";
    }
    html += current < pages ? '<a class="p-2 hover:text-primary" href="' + pageHref(current + 1) + '" data-page="' + (current + 1) + '">›</a>' : '<span class="p-2 text-outline">›</span>';
    nav.innerHTML = html;
  }

  function paintChipState(state) {
    document.querySelectorAll("[data-facet]").forEach(function (button) {
      var on = state[button.getAttribute("data-facet-group")] === button.getAttribute("data-facet");
      button.setAttribute("aria-pressed", on ? "true" : "false");
      if (on) {
        button.classList.add("bg-primary", "text-on-primary");
        button.classList.remove("bg-surface-container", "bg-surface-container-low");
      } else if (button.getAttribute("data-chip") === "true") {
        button.classList.remove("bg-primary", "text-on-primary");
      }
    });
  }

  function setFacet(group, value, appendMode) {
    writeUrl(function (query) {
      if (!value || query.get(group) === value) query.delete(group);
      else query.set(group, value);
      query.delete("page");
      query.delete("viewmode");
      if (appendMode) query.set("viewmode", "append");
    });
    bootCatalog();
  }

  function popover(anchor, group, options) {
    closePopover();
    var panel = document.createElement("div");
    panel.className = "z-[80] bg-surface border border-surface-variant shadow-lg p-2";
    panel.setAttribute("data-filter-popover", group);
    if (window.innerWidth < 768) {
      panel.style.position = "fixed";
      panel.style.left = "0";
      panel.style.right = "0";
      panel.style.bottom = "0";
      panel.style.maxHeight = "70vh";
      panel.style.overflow = "auto";
    } else {
      panel.style.position = "absolute";
      panel.style.top = "100%";
      panel.style.left = "0";
      panel.style.minWidth = "200px";
      var parent = anchor.parentElement;
      if (parent && getComputedStyle(parent).position === "static") parent.style.position = "relative";
    }
    options.forEach(function (option) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "block w-full text-left px-3 py-2 font-label-caps text-label-caps uppercase tracking-wider hover:bg-surface-container";
      button.textContent = option[0];
      button.addEventListener("click", function () {
        if (String(option[1]).charAt(0) === "/") {
          window.location.href = option[1];
          return;
        }
        if (group === "category") setFacet("theme", option[1]);
        else setFacet(group, option[1]);
        closePopover();
      });
      panel.appendChild(button);
    });
    var footer = document.createElement("div");
    footer.className = "flex gap-2 p-2 border-t border-surface-variant mt-2";
    var clear = document.createElement("button");
    clear.type = "button";
    clear.className = "flex-1 h-10 border border-primary text-primary font-label-caps text-label-caps uppercase";
    clear.textContent = "Clear all";
    clear.addEventListener("click", function () {
      writeUrl(function (query) {
        ["theme", "color", "size", "style", "room", "tab", "finish", "material", "page", "viewmode"].forEach(function (key) { query.delete(key); });
      });
      closePopover();
      bootCatalog();
    });
    var show = document.createElement("button");
    show.type = "button";
    show.className = "flex-1 h-10 bg-primary text-on-primary font-label-caps text-label-caps uppercase";
    show.textContent = "Show products";
    show.addEventListener("click", closePopover);
    footer.appendChild(clear);
    footer.appendChild(show);
    panel.appendChild(footer);
    (window.innerWidth < 768 ? document.body : anchor.parentElement).appendChild(panel);
    openPopover = panel;
  }

  var OPTION_SETS = {
    category: [["All", ""], ["Posters", "/collections/posters-prints"], ["Canvas", "/collections/canvas-art"], ["Frames", "/collections/frames-accessories"], ["Photography", "photography"], ["Abstract", "abstract"], ["Botanical", "botanical"], ["Typography", "typography"]],
    theme: [["Abstract", "abstract"], ["Botanical", "botanical"], ["Black & White", "black-white"], ["Photography", "photography"], ["Vintage", "vintage"], ["Minimalist", "minimalist"], ["Illustrations", "illustrations"], ["Typography", "typography"]],
    color: [["Black", "black"], ["White", "white"], ["Beige", "beige"], ["Sand", "sand"], ["Green", "green"], ["Blue", "blue"], ["Terracotta", "terracotta"], ["Grey", "grey"], ["Pink", "pink"], ["Red", "red"]],
    size: [["5 × 7", "5x7"], ["8 × 12", "8x12"], ["12 × 16", "12x16"], ["16 × 20", "16x20"], ["20 × 20", "20x20"], ["20 × 28", "20x28"], ["28 × 39", "28x39"], ["39 × 59", "39x59"]],
    style: [["Scandinavian", "scandinavian"], ["Minimalist", "minimal"], ["Contemporary", "contemporary"], ["Romantic", "romantic"], ["Playful", "playful"], ["Timeless Classic", "timeless"], ["Bold & Eclectic", "bold"], ["Modern & Urban", "modern"]],
    room: [["Living Room", "living-room"], ["Bedroom", "bedroom"], ["Kitchen & Dining", "kitchen"], ["Kids Room", "kids"], ["Office", "office"], ["Hallway", "hallway"]],
    finish: [["Black", "black"], ["White", "white"], ["Natural Oak", "oak"], ["Dark Oak", "dark-oak"], ["Metal", "metal"], ["Accessories", "accessory"]],
    material: [["Paper", "paper"], ["Canvas", "canvas"], ["Wood", "wood"], ["Metal", "metal"]],
    sort_by: [["Featured", "manual"], ["Best Selling", "best-selling"], ["Newest", "created-descending"], ["Price Low → High", "price-ascending"], ["Price High → Low", "price-descending"], ["A → Z", "title-ascending"], ["Z → A", "title-descending"]]
  };

  function cleanLabel(value) {
    return String(value || "").replace(/\b(expand_more|unfold_more|keyboard_arrow_down|tune|arrow_forward)\b/gi, "").replace(/\s+/g, " ").trim();
  }

  function pageHref(page) {
    var url = new URL(window.location.href);
    url.searchParams.set("page", String(page));
    url.searchParams.delete("viewmode");
    return url.pathname + url.search;
  }

  function groupFor(label) {
    var value = cleanLabel(label).toLowerCase();
    if (value.indexOf("all categor") !== -1) return "category";
    if (value.indexOf("refine") !== -1 || value === "size") return "size";
    if (value.indexOf("theme") !== -1) return "theme";
    if (value.indexOf("color") !== -1) return "color";
    if (value.indexOf("style") !== -1) return "style";
    if (value.indexOf("room") !== -1) return "room";
    if (value.indexOf("frame type") !== -1) return "finish";
    if (value.indexOf("material") !== -1) return "material";
    if (value.indexOf("sort") !== -1) return "sort_by";
    return "";
  }

  function chipValue(label) {
    var map = {
      abstract: ["theme", "abstract"],
      botanical: ["theme", "botanical"],
      "black & white": ["theme", "black-white"],
      photography: ["theme", "photography"],
      vintage: ["theme", "vintage"],
      minimalist: ["theme", "minimalist"],
      illustrations: ["theme", "illustrations"],
      typography: ["theme", "typography"],
      "all canvas": ["theme", ""],
      "all categories": ["theme", ""],
      "new this week": ["tab", "new_this_week"],
      "studio noir exclusives": ["tab", "studio_noir_exclusive"],
      "warm earth tones": ["tab", "warm_earth_tones"],
      "modern sculptural": ["tab", "modern_sculptural"],
      "curated pairs": ["tab", "warm_earth_tones"]
    };
    return map[label.toLowerCase()] || null;
  }

  var catalogGrid = null;
  var catalogCards = [];

  function bootCatalog() {
    if (!catalogGrid) return;
    applyCatalog(catalogGrid, catalogCards);
  }

  function initCatalog() {
    catalogGrid = findProductGrid();
    if (!catalogGrid) return;
    catalogCards = cardsIn(catalogGrid);
    catalogCards.forEach(function (card, index) {
      var facet = facetsFor(card, index);
      Object.keys(facet).forEach(function (key) { card.dataset[key] = facet[key]; });
    });
    document.querySelectorAll("button, a").forEach(function (node) {
      if (node.closest("header") || node.closest("#JournalGrid")) return;
      var label = cleanLabel(text(node));
      if (!label || label.length > 40) return;
      var chip = chipValue(label);
      if (/^all new in/i.test(label) && node.tagName === "BUTTON") {
        node.setAttribute("data-facet-group", "tab");
        node.setAttribute("data-facet", "");
        node.setAttribute("data-chip", "true");
        return;
      }
      if (chip && node.tagName === "BUTTON") {
        node.setAttribute("data-facet-group", chip[0]);
        node.setAttribute("data-facet", chip[1]);
        node.setAttribute("data-chip", "true");
        return;
      }
      if (node.tagName === "A" && node.hasAttribute("data-finish")) return;
      var group = groupFor(label);
      if (group && node.tagName === "BUTTON" && OPTION_SETS[group]) node.setAttribute("data-filter-open", group);
    });
    document.querySelectorAll("span").forEach(function (node) {
      if (text(node).length < 40 && /^refine dimensions/i.test(text(node))) {
        node.setAttribute("data-filter-open", "size");
        node.style.cursor = "pointer";
      }
    });
    document.querySelectorAll("select").forEach(function (select) {
      if (select.closest("[data-shopify-filters]") || select.form && select.form.getAttribute("action")) return;
      if (/sort/i.test(select.id) || /featured|price/i.test(text(select))) {
        select.innerHTML = OPTION_SETS.sort_by.map(function (option) {
          return '<option value="' + option[1] + '">' + option[0] + "</option>";
        }).join("");
        select.value = catalogState().sort || "manual";
        select.addEventListener("change", function () {
          writeUrl(function (query) {
            query.set("sort_by", select.value);
            query.delete("page");
          });
          bootCatalog();
        });
      }
    });
    bootCatalog();
  }

  function linkArticle(card) {
    var heading = card.querySelector("h2, h3");
    if (!heading) return;
    var href = "/search?view=catalog&q=story-" + slug(text(heading));
    var image = card.querySelector("img");
    if (image && !image.closest("a")) {
      var wrap = document.createElement("a");
      wrap.href = href;
      wrap.className = "block w-full h-full";
      image.parentNode.insertBefore(wrap, image);
      wrap.appendChild(image);
    } else if (image && image.closest("a") && image.closest("a").getAttribute("href").indexOf("story-") === -1) {
      image.closest("a").setAttribute("href", href);
    }
    if (!heading.querySelector("a")) {
      var link = document.createElement("a");
      link.href = href;
      link.textContent = text(heading);
      heading.textContent = "";
      heading.appendChild(link);
    } else {
      heading.querySelector("a").setAttribute("href", href);
    }
    Array.prototype.forEach.call(card.querySelectorAll("span, a"), function (node) {
      if (!/read more|read article/i.test(text(node))) return;
      if (node.tagName === "A") {
        node.setAttribute("href", href);
        return;
      }
      var anchor = document.createElement("a");
      anchor.href = href;
      anchor.className = node.className;
      anchor.innerHTML = node.innerHTML;
      node.replaceWith(anchor);
    });
    var category = "";
    Array.prototype.forEach.call(card.querySelectorAll("span"), function (node) {
      var label = text(node);
      if (!category && /^(how to|inspiration|trends|artists|interviews|new in)$/i.test(label)) category = slug(label);
    });
    card.dataset.category = category;
  }

  function journalCards() {
    var grid = document.getElementById("JournalGrid");
    if (!grid) return [];
    return Array.prototype.filter.call(grid.children, function (node) { return node.tagName === "ARTICLE"; });
  }

  function paintJournal() {
    var root = document.querySelector("[data-journal-fallback]");
    if (!root) return;
    var cards = journalCards();
    cards.forEach(linkArticle);
    var featured = root.querySelector("article.grid");
    if (featured) linkArticle(featured);
    var tag = params().get("tag") || "";
    var page = Math.max(1, parseInt(params().get("page") || "1", 10));
    var append = params().get("viewmode") === "append";
    var filtered = cards.filter(function (card) { return !tag || card.dataset.category === tag; });
    var size = 6;
    var start = append ? 0 : (page - 1) * size;
    var end = append ? page * size : start + size;
    cards.forEach(function (card) {
      var index = filtered.indexOf(card);
      card.style.display = index >= start && index < end ? "" : "none";
    });
    var count = document.getElementById("JournalCount");
    if (count) count.textContent = filtered.length + (filtered.length === 1 ? " Article" : " Articles");
    var more = document.getElementById("JournalLoadMore");
    if (more) more.style.display = filtered.length > end ? "" : "none";
    var pager = document.getElementById("JournalPager");
    var pages = Math.ceil(filtered.length / size);
    if (pager) {
      if (pages < 2) {
        pager.innerHTML = "";
      } else {
        var html = page > 1 ? '<a class="p-2" href="' + pageHref(page - 1) + '" data-journal-page="' + (page - 1) + '">‹</a>' : '<span class="p-2 text-outline">‹</span>';
        for (var i = 1; i <= pages; i += 1) {
          html += i === page
            ? '<span aria-current="page" class="w-8 h-8 inline-flex items-center justify-center bg-primary text-on-primary">' + i + "</span>"
            : '<a class="w-8 h-8 inline-flex items-center justify-center hover:bg-surface-container" href="' + pageHref(i) + '" data-journal-page="' + i + '">' + i + "</a>";
        }
        html += page < pages ? '<a class="p-2" href="' + pageHref(page + 1) + '" data-journal-page="' + (page + 1) + '">›</a>' : '<span class="p-2 text-outline">›</span>';
        pager.innerHTML = html;
      }
    }
    document.querySelectorAll("[data-journal-filter]").forEach(function (link) {
      var on = (link.getAttribute("data-journal-filter") || "") === tag;
      link.classList.toggle("text-primary", on);
      link.classList.toggle("font-medium", on);
      link.classList.toggle("border-b-2", on);
      link.classList.toggle("border-primary", on);
      link.classList.toggle("text-on-surface-variant", !on);
    });
    var empty = document.getElementById("JournalEmpty");
    if (filtered.length === 0) {
      if (!empty) {
        empty = document.createElement("p");
        empty.id = "JournalEmpty";
        empty.className = "col-span-full font-body-lg text-on-surface-variant py-8";
        empty.textContent = "No stories in this category yet.";
        document.getElementById("JournalGrid").appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  document.addEventListener("click", function (event) {
    var clearFilters = event.target.closest("button");
    if (clearFilters && /^clear all$/i.test(text(clearFilters)) && catalogGrid) {
      event.preventDefault();
      writeUrl(function (query) {
        ["theme", "color", "size", "style", "room", "tab", "finish", "material", "page", "viewmode", "sort_by"].forEach(function (key) { query.delete(key); });
      });
      bootCatalog();
      return;
    }
    var finish = event.target.closest("[data-finish]");
    if (finish) {
      event.preventDefault();
      setFacet("finish", finish.getAttribute("data-finish"));
      var grid = document.getElementById("grid");
      if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    var opener = event.target.closest("[data-filter-open]");
    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      popover(opener, opener.getAttribute("data-filter-open"), OPTION_SETS[opener.getAttribute("data-filter-open")]);
      return;
    }
    var chip = event.target.closest("[data-chip]");
    if (chip) {
      event.preventDefault();
      var group = chip.getAttribute("data-facet-group");
      var value = chip.getAttribute("data-facet");
      if (!value) {
        writeUrl(function (query) { query.delete(group); query.delete("page"); query.delete("viewmode"); });
        bootCatalog();
      } else {
        setFacet(group, value);
      }
      return;
    }
    var pageLink = event.target.closest("[data-page]");
    if (pageLink) {
      event.preventDefault();
      writeUrl(function (query) {
        query.set("page", pageLink.getAttribute("data-page"));
        query.delete("viewmode");
      });
      bootCatalog();
      return;
    }
    var journalPage = event.target.closest("[data-journal-page]");
    if (journalPage) {
      event.preventDefault();
      writeUrl(function (query) {
        query.set("page", journalPage.getAttribute("data-journal-page"));
        query.delete("viewmode");
      });
      paintJournal();
      return;
    }
    var journalFilter = event.target.closest("[data-journal-filter]");
    if (journalFilter && document.querySelector("[data-journal-fallback]")) {
      event.preventDefault();
      writeUrl(function (query) {
        var tag = journalFilter.getAttribute("data-journal-filter");
        if (tag) query.set("tag", tag);
        else query.delete("tag");
        query.delete("page");
        query.delete("viewmode");
        query.set("view", "catalog");
        query.set("q", "journal");
      });
      paintJournal();
      return;
    }
    var more = event.target.closest("a, button");
    if (more && /show more|load more/i.test(text(more)) && !more.hasAttribute("data-collection-more") && !more.hasAttribute("data-journal-next")) {
      if (document.getElementById("JournalLoadMore") === more) {
        event.preventDefault();
        writeUrl(function (query) {
          var page = Math.max(1, parseInt(query.get("page") || "1", 10)) + (query.get("viewmode") === "append" ? 1 : 1);
          if (query.get("viewmode") !== "append") page = 2;
          else page = Math.max(1, parseInt(query.get("page") || "1", 10)) + 1;
          query.set("page", String(page));
          query.set("viewmode", "append");
        });
        paintJournal();
        return;
      }
      if (catalogGrid && (catalogGrid.parentElement.contains(more) || text(more).length < 40)) {
        event.preventDefault();
        writeUrl(function (query) {
          var page = query.get("viewmode") === "append" ? Math.max(1, parseInt(query.get("page") || "1", 10)) + 1 : 2;
          query.set("page", String(page));
          query.set("viewmode", "append");
        });
        bootCatalog();
      }
    }
    if (openPopover && !event.target.closest("[data-filter-popover]") && !event.target.closest("[data-filter-open]")) closePopover();
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-collection-more], [data-journal-next]");
    if (!button) return;
    event.preventDefault();
    var url = button.getAttribute("data-collection-more") || button.getAttribute("data-journal-next");
    var gridId = button.hasAttribute("data-journal-next") ? "JournalGrid" : "CollectionGrid";
    var cardSelector = button.hasAttribute("data-journal-next") ? "[data-journal-card]" : ":scope > *";
    fetch(url, { credentials: "same-origin" })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var grid = document.getElementById(gridId);
        var incoming = doc.querySelectorAll("#" + gridId + " " + (button.hasAttribute("data-journal-next") ? "[data-journal-card]" : ":scope > *"));
        if (button.hasAttribute("data-collection-more")) incoming = doc.querySelectorAll("#CollectionGrid > *");
        incoming.forEach(function (node) { grid.appendChild(document.importNode(node, true)); });
        var next = doc.querySelector(button.hasAttribute("data-journal-next") ? "[data-journal-next]" : "[data-collection-more]");
        if (next) button.setAttribute(button.hasAttribute("data-journal-next") ? "data-journal-next" : "data-collection-more", next.getAttribute(button.hasAttribute("data-journal-next") ? "data-journal-next" : "data-collection-more"));
        else button.style.display = "none";
        document.dispatchEvent(new CustomEvent("noirplate:sync"));
        var freshPager = doc.querySelector("nav[aria-label='Pagination']");
        var pager = document.querySelector("nav[aria-label='Pagination']");
        if (freshPager && pager && button.hasAttribute("data-collection-more")) pager.replaceWith(document.importNode(freshPager, true));
      })
      .catch(function () {
        window.location.href = url;
      });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closePopover();
  });

  document.addEventListener("toggle", function (event) {
    if (!event.target || event.target.tagName !== "DETAILS" || !event.target.open) return;
    var form = event.target.closest("[data-shopify-filters]");
    if (!form) return;
    form.querySelectorAll("details[open]").forEach(function (item) {
      if (item !== event.target) item.removeAttribute("open");
    });
  }, true);

  window.addEventListener("popstate", function () {
    bootCatalog();
    paintJournal();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initCatalog();
      paintJournal();
    });
  } else {
    initCatalog();
    paintJournal();
  }
})();
